/**
 * Short 3-4 char tag derived from a player/team name (reference `playerAbbr()`,
 * LA48AF_1_updated.HTM) — shown as a `.sc-abbr`-style chip next to a name when
 * no real club/country abbreviation is available for that player.
 *
 * @param name - Raw player/team display name.
 * @returns Uppercase abbreviation, or '' when no usable name is given.
 */
export function playerAbbr(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) {
    return '';
  }
  const words = trimmed.replace(/\./g, ' ').split(/[\s/]+/).filter(Boolean);
  const last = words[words.length - 1] ?? trimmed;
  let abbr = last.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
  if (abbr.length < 3 && words.length > 1) {
    abbr = (words[0].slice(0, 2) + last.slice(0, 2))
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 4);
  }
  return (abbr || trimmed.slice(0, 4)).slice(0, 4).toUpperCase();
}
